export const INVALID_USER = "Your username or password is invalid"
export const INVALID_USERNAME = "Your username is invalid"

// Authentication error messages
export const INVALID_2FA_CODE = "That code isn't correct. Check your authenticator app and try again."
export const ACCOUNT_LOCKED = "Your account has been locked. Please contact Prime support."
export const TOO_MANY_ATTEMPTS = "Too many attempts. Please wait a few minutes and try again."
export const SERVER_ERROR = "Something went wrong on our end. Please try again shortly."
export const NETWORK_ERROR = "Can't reach the server. Check your connection and try again."
export const GENERIC_LOGIN_ERROR = "We couldn't sign you in. Please try again or contact support."
